module.exports = __webpack_public_path__ + "static/media/customer-fritolay.8db9a49f.png";